// src/components/ManualEnrollForm.jsx
// 受講者を1人ずつ手で追加するフォーム【2026-10-20 ClassRosterPane から切り出し】
//
//   授業スケジュール（授業管理）と、学生管理の授業別の名簿の両方で使う。
//   ・アプリ登録済みの学生 … 学籍番号だけで追加（照合用IDでも当たる）
//   ・未登録の学生         … 氏名も入れると「アカウント未作成」の仮の受講者として追加。
//                            本人があとで登録すると、そのアカウントに引き継がれる。
//   サーバー: POST /api/schedule/classes/:classId/enrollments { studentId, name? }
//
//   classId を渡せばその授業に固定。渡さずに classes を渡すと、授業を選ぶプルダウンが出る。
import React, { useState } from 'react';
import { STATUS } from './StudentStatusBadges';

export default function ManualEnrollForm({ classId = null, classes = [], auth, setErr, setMsg, onAdded }) {
  const [pickedClassId, setPickedClassId] = useState('');
  const [studentId, setStudentId] = useState('');
  const [name, setName]           = useState('');
  const [needName, setNeedName]   = useState(false);   // 未登録だったので氏名を求めている
  const [busy, setBusy]           = useState(false);
  const targetId = classId || pickedClassId;

  const submit = async (e) => {
    e.preventDefault();
    const sid = studentId.trim();
    if (!sid || !targetId) return;
    setBusy(true); setErr(''); setMsg('');
    try {
      const res = await fetch('/api/schedule/classes/' + targetId + '/enrollments', {
        method: 'POST', headers: auth(), body: JSON.stringify({ studentId: sid, name: name.trim() || undefined }),
      });
      const d = await res.json();
      if (d.code === 'STUDENT_NOT_FOUND') {
        // まだアプリに登録していない学生。氏名を入れてもらえば仮の受講者として追加できる
        setNeedName(true);
        throw new Error(d.message);
      }
      if (!d.success) throw new Error(d.message || '追加に失敗しました');
      const cn = !classId && (classes.find(c => String(c.id) === String(targetId)) || {}).name;
      setMsg((cn ? '「' + cn + '」に ' : '') + (d.message || '履修者を追加しました'));
      setStudentId(''); setName(''); setNeedName(false);
      if (onAdded) onAdded(d);
    } catch (e2) { setErr(e2.message); }
    finally     { setBusy(false); }
  };

  return (
    <form onSubmit={submit}>
      <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'end', flexWrap: 'wrap' }}>
        {!classId && (
          <div style={{ flex: '1 1 200px' }}>
            <label style={{ display: 'block', fontSize: '0.75rem', color: '#555' }}>追加する授業</label>
            <select value={pickedClassId} onChange={e => setPickedClassId(e.target.value)}
                    aria-label="追加する授業" style={{ width: '100%' }}>
              <option value="">授業を選んでください</option>
              {classes.map(c => (
                <option key={c.id} value={c.id}>{c.name}{c.semester ? '（' + c.semester + '）' : ''}</option>
              ))}
            </select>
          </div>
        )}
        <div style={{ flex: '1 1 150px' }}>
          <label style={{ display: 'block', fontSize: '0.75rem', color: '#555' }}>学籍番号</label>
          <input value={studentId} aria-label="学籍番号"
                 onChange={e => { setStudentId(e.target.value); setNeedName(false); }}
                 placeholder="例: b250535" style={{ width: '100%' }} />
        </div>
        <div style={{ flex: '1 1 150px' }}>
          <label style={{ display: 'block', fontSize: '0.75rem', color: needName ? '#b45309' : '#555' }}>
            氏名{needName ? '（未登録の学生なので入れてください）' : '（アプリ未登録の学生のときだけ）'}
          </label>
          <input value={name} aria-label="氏名" autoFocus={needName} key={needName ? 'need' : 'opt'}
                 onChange={e => setName(e.target.value)}
                 placeholder="例: 龍谷 太郎"
                 style={{ width: '100%', ...(needName ? { borderColor: '#f59e0b', background: '#fffbeb' } : {}) }} />
        </div>
        <button className="btn-primary" type="submit"
                disabled={busy || !targetId || !studentId.trim() || (needName && !name.trim())}>
          {busy ? '追加中…' : needName ? '仮の受講者として追加' : '追加'}
        </button>
      </div>
      <div style={{ fontSize: '0.72rem', color: '#6b7280', marginTop: '0.25rem' }}>
        アプリに登録済みの学生は学籍番号だけで追加できます。未登録の学生は氏名も入れると「{STATUS.noAccount.label}」として追加し、
        本人があとで登録するとそのまま引き継がれます。
      </div>
    </form>
  );
}
